const CUID_PATTERN = /^00000000-0000-c000-8000-(\d{12})$/;

export function getNodeIdFromCuid(cuid: string): number {
  /**
   * Extract node ID from a CUID.
   *
   * This function reverses the encoding done by getCuidForNodeId, extracting
   * the original 32-bit signed integer node ID from the CUID format.
   *
   * The CUID format is: 00000000-0000-c000-8000-{nodeId padded to 12 digits}
   *
   * @param cuid - The CUID string to extract the node ID from
   * @returns The original node ID as a number
   * @throws TypeError if the CUID format is invalid
   */

  if (typeof cuid !== "string") {
    throw new TypeError("CUID must be a string");
  }

  const match = cuid.match(CUID_PATTERN);
  if (!match) {
    throw new TypeError(
      "Invalid CUID format. Expected format: 00000000-0000-c000-8000-############",
    );
  }

  const nodeIdString = match[1];
  const nodeId = Number.parseInt(nodeIdString, 10);

  // Validate that the parsed number is within the expected range
  if (Number.isNaN(nodeId)) {
    throw new TypeError("Invalid node ID in CUID");
  }

  return nodeId;
}
